import styled from "styled-components"
import tw from "twin.macro"

const CenterColumn = styled.div`
  ${tw`text-center`}
`

export default CenterColumn
